import SvgIcon from '@mui/material/SvgIcon'
import useStyles from './FilterIcon.styles'

type Props = {
    className?: string,
    newStyling?: boolean,
}

const defaultProps: Props = {
    className: '',
    newStyling: false,
}

const FilterIcon = ({
    className,
    newStyling,
}: Props) => {
    const {
        classes,
        cx,
    } = useStyles()

    // TODO-JG: Make newStyling default view after changing tables to new SkyNetDataGrid
    if (newStyling) {
        return (
            <SvgIcon
                className={cx(classes.newStylingIcon, className)}
                viewBox="0 0 17 15"
            >
                <path
                    d="M7.99996 16C7.71662 16 7.47913 15.9042 7.28746 15.7125C7.09579 15.5208 6.99996 15.2833 6.99996 15V9L1.19996 1.6C0.949958 1.26667 0.912458 0.916667 1.08746 0.55C1.26246 0.183333 1.56662 0 1.99996 0H16C16.4333 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9041 15.5208 10.7125 15.7125C10.5208 15.9042 10.2833 16 9.99996 16H7.99996Z"
                />
            </SvgIcon>
        )
    }
    return (
        <SvgIcon
            className={cx(classes.icon, className)}
            viewBox="0 0 15 15"
        >
            <path
                d="M2 2.054464L15.230225 2l-5.132897 4.825055-.123136 8.311554-3.318686-2.544346.142712-5.715111z"
            />
        </SvgIcon>
    )
}

FilterIcon.defaultProps = defaultProps

export default FilterIcon
